export default __webpack_public_path__ + "static/media/lifestyle-logo.4fc4ff88.png";